import { renderSlot as _renderSlot, resolveDynamicComponent as _resolveDynamicComponent, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, createCommentVNode as _createCommentVNode, Transition as _Transition, Teleport as _Teleport } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "pointer-events-none fixed inset-x-0 bottom-4 z-2500 flex justify-center px-4"
};
const _hoisted_2 = { class: "min-w-0 flex-1" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
        _createVNode(_Transition, {
            "enter-active-class": "transition duration-200 ease-out",
            "enter-from-class": "translate-y-2 opacity-0",
            "leave-active-class": "transition duration-150 ease-in",
            "leave-to-class": "translate-y-2 opacity-0"
        }, {
            default: _withCtx(() => [
                ($setup.isVisible)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                        _createElementVNode("div", {
                            class: _normalizeClass($setup.surfaceClass),
                            role: "status",
                            "aria-live": "polite"
                        }, [
                            _renderSlot(_ctx.$slots, "icon", {}, () => [
                                (_openBlock(), _createBlock(_resolveDynamicComponent($setup.icon), {
                                    class: _normalizeClass($setup.iconClass),
                                    "aria-hidden": "true"
                                }, null, 8 /* PROPS */, ["class"]))
                            ]),
                            _createElementVNode("div", _hoisted_2, [
                                _renderSlot(_ctx.$slots, "default"),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.messages, (line) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                        key: line,
                                        class: "truncate"
                                    }, _toDisplayString(line), 1 /* TEXT */));
                                }), 128 /* KEYED_FRAGMENT */))
                            ]),
                            _createElementVNode("div", {
                                class: _normalizeClass(["w-px flex-none bg-en-blue-300", $props.dense ? 'h-4' : 'h-6']),
                                "aria-hidden": "true"
                            }, null, 2 /* CLASS */),
                            _createVNode($setup["EnButton"], {
                                "aria-label": $setup.t('common.buttons.close'),
                                class: _normalizeClass([$props.dense ? 'size-6' : 'size-8', "flex-none text-background hover:bg-transparent hover:text-en-red-400"]),
                                size: "icon-sm",
                                variant: "ghost",
                                "no-shadow": "",
                                "static-id": "snackbar-close",
                                onClick: $setup.close
                            }, {
                                icon: _withCtx(() => [
                                    _createVNode($setup["CloseIcon"], {
                                        class: _normalizeClass($props.dense ? 'size-3.5' : 'size-4')
                                    }, null, 8 /* PROPS */, ["class"])
                                ]),
                                _: 1 /* STABLE */
                            }, 8 /* PROPS */, ["aria-label", "class"])
                        ], 2 /* CLASS */)
                    ]))
                    : _createCommentVNode("v-if", true)
            ]),
            _: 3 /* FORWARDED */
        })
    ]));
}
